import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";
import fl from "./logo.png";

const Footer = () => {
  return (
    <div className="container-f" style={{ width: "100vw" }}>
    
      <footer
        className="text-center text-lg-start text-white"
        style={{ backgroundColor: "black", width: "100vw" }}
      >
        {/* Section: Social media */}
        <section
          className="d-flex justify-content-between "
          style={{ backgroundColor: "black", width: "100vw" }}
        ></section>
        {/* Section: Social media */}

        {/* Section: Links  */}
        <section>
          <div className="container text-center text-md-start mt-5">
            <div className="row mt-3">
              {/* Column 1 */}
              <div className="col-md-3 col-lg-4 col-xl-3  mb-4">
                <img src={fl} alt="footer-logo" style={{ width: "9rem" }} />

                <h6
                  className="namec text-white text-uppercase fw-bold"
                  style={{ textDecoration: "none" }}
                >
                  <br /> Property92.pk
                </h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    width: "60px",
                    backgroundColor: "#7c4dff",
                    height: "0px",
                    color: "#0b1f40",
                  }}
                />
                <p className="text-warning para-f">
                  Discover your dream home <br /> with us where quality meets <br />
                  comfort and
                  every property <br /> is a perfect fit.
                </p>
              </div>

              {/* Column 3 */}
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold text-danger">Useful links</h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    width: "60px",
                    backgroundColor: "#7c4dff",
                    height: "0px",
                    color: "#0b1f40",
                  }}
                />
                <p className="para-f">
                  <Link to="/Aboutpage" className="text-white">
                    About Us
                  </Link>
                </p>
                <p className="para-f">
                  <a href="/Services" className="text-white">
                    Our Services
                  </a>
                </p>
                <p className="para-f">
                  <a href="/Why" className="text-white">
                    Why Property92.pk
                  </a>
                </p>
                <p className="para-f">
                  <a href="/Find" className="text-white">
                    Find Us
                  </a>
                </p>
                <p className="para-f">
                  <Link to="/Contact" className="text-white">
                    Contact Us
                  </Link>
                </p>
              </div>

              {/* Column 4 */}
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold text-danger">Our Cities</h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    width: "60px",
                    backgroundColor: "#7c4dff",
                    height: "0px",
                    color: "#0b1f40",
                  }}
                />

                <p className="text-white para-f">Islamabad</p>
                <p className="text-white para-f">Lahore</p>
                <p className="text-white para-f">Faisalabad</p>
                <p className="text-white para-f">Sialkot</p>
                <p className="text-white para-f">Gujranwala</p>
                <p className="text-white para-f">Jhelum</p>
              </div>
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold text-danger">Contact</h6>
                <hr
                  className="mb-4 mt-0 d-inline-block mx-auto"
                  style={{
                    width: "60px",
                    backgroundColor: "#7c4dff",
                    height: "0px",
                    color: "#0b1f40",
                  }}
                />

<a href="mailto:naeem@property92.pk"
              target="_blank"
              rel="noopener noreferrer"><p className="text-warning para-f">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <br />
                  naeem@property92.pk
                </p></a>
                <a href="https://wa.me/+923222999888"
              target="_blank"
              rel="noopener noreferrer"><p className="text-warning para">
                  <FontAwesomeIcon icon={faPhone} />
                  <br /> +92 3 222 999 888
                </p></a>
              </div>
            </div>
          </div>
        </section>
        {/* Section: Links */}

        {/* Copyright */}
        <div className="text-center text-warning p-2 para-f">
          <hr />© Copyright 2025 Property92.pk -
          <a className="text-warning" href="https://property92.com.pk/">
            {" "}
              All Rights Reserved
          </a>
        </div>
      </footer>
      {/* Footer */}
    </div>
  );
};

export default Footer;
